<template>
  <div>
    <div class="lpt-mdl" role="dialog" style="z-index: 10">
      <div class="modal-dialog generic-modal" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">
              {{title}}
              <button type="button" class="close" aria-label="Close" @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </h3>
          </div>
          <div class="modal-body">
            <p v-html="body"/>
          </div>
          <div class="modal-footer">
            <button v-if="showConfirm" type="button" class="btn btn-primary primaryBgColor" @click="$emit('confirm')" v-text="$t('global.modal.confirm')"/>
            <button type="button" class="btn btn-secondary primaryBgColor" @click="$emit('close')" v-text="$t('global.modal.close')"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GenericModal",
  props: {
    title: {
      type: String,
      default: "Warning",
    },
    body: {
      type: String,
      required: true,
    },
    showConfirm: {
      type: Boolean,
      required: true,
    },
  }
}
</script>

<style>
.generic-modal {
  margin-top: 25%;

}

.lpt-mdl {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-overflow-scrolling: touch;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.57);
}
</style>







// WEBPACK FOOTER //
// src/global/notificationCenter/components/GenericModal.vue